import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { Nullable, UserWithToken, WithData } from './api.types';

export type UserSetting = {
  id: number;
  userId: number;
  key: string;
  value: unknown;
  createdAt: string;
  updatedAt: string;
};

export const getUserSetting = async (
  user: Nullable<UserWithToken>,
  key: string
) =>
  getGraphQLQueryClient(user).request<WithData<UserSetting | null>>(
    gql`
      query userSetting($key: String!) {
        data: userSetting(key: $key) {
          id
          userId
          key
          value
          createdAt
          updatedAt
        }
      }
    `,
    { key }
  );

export const saveUserSetting = async (
  user: Nullable<UserWithToken>,
  key: string,
  value: unknown
) =>
  getGraphQLQueryClient(user).request<WithData<UserSetting>>(
    gql`
      mutation saveUserSetting($key: String!, $value: JSON!) {
        data: saveUserSetting(key: $key, value: $value) {
          id
          userId
          key
          value
          createdAt
          updatedAt
        }
      }
    `,
    { key, value }
  );
